import dynamic from 'next/dynamic';
import { memo, useContext } from 'react';
import { useIsNative } from '~/context/common/DeviceContext';
import { useConfiguration } from '~/context/common/StaticContext';
import UserContext, { useIsLoggedIn } from '~/context/common/UserContext';
import ModalContext from '~/context/home/ModalContext';

const CreditKarmaPromoModal = dynamic(
  () =>
    import(
      /* webpackChunkName: "CreditKarmaPromoModal" */ '@/common/Modals/CreditKarmaPromoModal'
    ),
  { ssr: false }
);

const CreateSavedSearchModal = dynamic(
  () =>
    import(
      /* webpackChunkName: "CreateSavedSearchModal" */ './Modals/SearchAlert/CreateSavedSearchModal'
    ),
  { ssr: false }
);

const SaveSearchModal = dynamic(
  () =>
    import(
      /* webpackChunkName: "SaveSearchModal" */ './Modals/SaveSearch/SaveSearchModal'
    ),
  { ssr: false }
);

const SoftPullModal = dynamic(
  () =>
    import(/* webpackChunkName: "SoftPullModal" */ './Modals/SoftPullModal'),
  { ssr: false }
);

type OwnProps = {
  loadAuthedModals: boolean;
  loadCreditKarmaPromoModal: boolean;
  loadSoftPullMfe: boolean;
};

const ModalsContent = memo(
  ({
    loadAuthedModals,
    loadCreditKarmaPromoModal,
    loadSoftPullMfe
  }: OwnProps) => {
    const { isCreditKarmaPromoModalOpen, setCreditKarmaPromoModalOpen } =
      useContext(ModalContext);

    return (
      <>
        {loadAuthedModals && <CreateSavedSearchModal />}
        {loadAuthedModals && <SaveSearchModal />}
        {loadSoftPullMfe && <SoftPullModal />}
        {loadCreditKarmaPromoModal && (
          <CreditKarmaPromoModal
            isCreditKarmaPromoModalOpen={isCreditKarmaPromoModalOpen}
            setCreditKarmaPromoModalOpen={setCreditKarmaPromoModalOpen}
          />
        )}
      </>
    );
  }
);

const Modals = () => {
  const isLoggedIn = useIsLoggedIn();
  const {
    userState: { isLoaded }
  } = useContext(UserContext);
  const { showCkPromo = false } = useConfiguration();
  const isNative = useIsNative();
  const isLoggedAndLoaded = isLoaded && isLoggedIn;

  return (
    <ModalsContent
      loadAuthedModals={isLoggedAndLoaded}
      loadCreditKarmaPromoModal={showCkPromo}
      loadSoftPullMfe={!isNative}
    />
  );
};

export default Modals;
